import i18n from "./i18n";

const LOCALE_MAP = { "zh-Hans": "zh-CN", "zh-Hant": "zh-TW", fil: "fil-PH", no: "nb-NO" };

export function locale() {
  return LOCALE_MAP[i18n.language] || i18n.language || "en";
}

export function formatDate(iso, opts = { day: "numeric", month: "long", year: "numeric" }) {
  if (!iso) return "";
  const d = new Date(iso.length <= 10 ? `${iso}T12:00:00` : iso);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return new Intl.DateTimeFormat(locale(), opts).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
}

export function formatShortDate(iso) {
  return formatDate(iso, { day: "numeric", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  return formatDate(iso, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function lifeSpan(m) {
  const b = m.birth_date ? formatDate(m.birth_date) : "";
  const d = m.death_date ? formatDate(m.death_date) : "";
  if (b && d) return `${b} — ${d}`;
  return b || d;
}

export function formatNumber(n) {
  try {
    return new Intl.NumberFormat(locale()).format(n || 0);
  } catch {
    return String(n || 0);
  }
}

export function pick(dict, lng) {
  if (!dict) return "";
  return dict[lng] || "";
}
